import GuidDevX from "devextreme/core/guid";

export default class Guid extends GuidDevX {
    static empty: Guid = new GuidDevX("00000000-0000-0000-0000-000000000000") as Guid;
    static max: Guid = new GuidDevX("FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF") as Guid;
    static IsGuidTemporaire = (guid: Guid) => guid.toString().startsWith("ffffffff") && !guid.equals(Guid.max);

    static newTemporary(): Guid {
        const suffix = Array.from({ length: 12 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
        return new Guid(`ffffffff-ffff-ffff-ffff-${suffix}`) as Guid;
    }

    equals(guid: Guid | Guid[] | string | undefined): boolean {
        if (!guid || !this || (!(guid instanceof GuidDevX) && !Array.isArray(guid) && typeof guid !== 'string')) {
            return false;
        }

        return Array.isArray(guid) ? guid.some(g => this.toString() === g.toString()) : this.toString() === guid.toString()
    }

    isEmpty = () => {
        return this.equals(Guid.empty)
    };
}

